var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOptiondots = function SvgOptiondots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.212 17a.709.709 0 1 1-1.417 0 .709.709 0 0 1 1.417 0M17.709 17a.709.709 0 1 1-1.418 0 .709.709 0 0 1 1.418 0M9.205 17a.709.709 0 1 1-1.417 0 .709.709 0 0 1 1.417 0"
  }))));
};
export { SvgOptiondots as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMDNlOTg5NDk0YjU2MGE1NTQwMDQ4YTRlZGFkZWE5OWIuc3ZnIjs=";